"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.campaign = void 0;
const helper_1 = require("./helper");
const campaign = (dateRange, filters) => (0, helper_1.getDimensionsQuery)({
    dimensions: ['Attribution.campaign'],
    measures: ['Attribution.conversions'],
}, dateRange, filters, rows => {
    return rows[0]
        .tablePivot()
        .filter(obj => Object.values(obj)[0] && Object.values(obj)[1])
        .sort((a, b) => Number(Object.values(b)[1]) - Number(Object.values(a)[1]))
        .map(obj => Object.values(obj)[0].toString());
});
exports.campaign = campaign;
//# sourceMappingURL=campaign.js.map